import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { openIntercomChat } from 'Utilities'

const OPEN_CHAT_PARAM = 'chat'
const OPEN_CHAT_PARAM_VALUE = '1'

export const useOpenIntercomChatFromUrl = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const isChatParamSet = (params: URLSearchParams) =>
      params.get(OPEN_CHAT_PARAM) === OPEN_CHAT_PARAM_VALUE

    // The shared deep link may carry the parameter inside the hash route
    // (#/contact?chat=1) or in front of it (/portal/app/?chat=1#/contact),
    // so both positions are accepted.
    if (
      !isChatParamSet(searchParams) &&
      !isChatParamSet(new URLSearchParams(window.location.search))
    ) {
      return
    }

    openIntercomChat(null)
  }, [searchParams])
}
